const isRTLSupported = (() => {
  const isOldIE = window.navigator.userAgent.indexOf('MSIE ') !== -1;
  const is11IE = window.navigator.userAgent.indexOf('Trident/') !== -1;
  return !isOldIE && !is11IE;
})();

export const isRightToLeft = (text: string): boolean => {
  const rtl = /[\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/;
  return rtl.test(text);
};

export function shouldUseRTL(text: string): boolean {
  return isRTLSupported && isRightToLeft(text);
}
